import { jsx } from "react/jsx-runtime";
import { Link, Text, UnorderedList, OrderedList, Heading } from "@chakra-ui/react";
import { MDXProvider } from "@mdx-js/react";
const components = {
  h1: (props) => /* @__PURE__ */ jsx(Heading, { as: "h1", size: "xl", mb: 4, ...props }),
  h2: (props) => /* @__PURE__ */ jsx(Heading, { as: "h2", size: "lg", mt: 6, mb: 4, ...props }),
  h3: (props) => /* @__PURE__ */ jsx(Heading, { as: "h3", size: "md", mb: 4, ...props }),
  ol: (props) => /* @__PURE__ */ jsx(OrderedList, { mb: 4, ...props }),
  ul: (props) => /* @__PURE__ */ jsx(UnorderedList, { mb: 4, ...props }),
  p: (props) => /* @__PURE__ */ jsx(Text, { mb: 4, ...props }),
  a: (props) => /* @__PURE__ */ jsx(Link, { ...props, color: "brand.400" })
};
const MdxProvider = ({ children }) => {
  return /* @__PURE__ */ jsx(MDXProvider, { components, children });
};
export {
  MdxProvider as M
};
